import { render, staticRenderFns } from "./CoalWashDataSet.vue?vue&type=template&id=5a540244&scoped=true&"
import script from "./CoalWashDataSet.vue?vue&type=script&lang=js&"
export * from "./CoalWashDataSet.vue?vue&type=script&lang=js&"
import style0 from "./CoalWashDataSet.vue?vue&type=style&index=0&id=5a540244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a540244",
  null
  
)

export default component.exports